import { createAction } from '@reduxjs/toolkit';

import { ANALYTICS_ACTIONS } from 'js/src/data/analytics/analytics-types';
import type { EDITOR_TAB_OPTIONS } from 'js/src/data/app/app-types';

export const initializeTabDurations = createAction<{
    media: number | undefined;
    music: number | undefined;
    style: number | undefined;
    format: number | undefined;
    voiceover: number | undefined;
    original_content: number | undefined;
}>(ANALYTICS_ACTIONS.INITIALIZE_TAB_DURATIONS);

export const syncDurationForTab = createAction<{
    currentTab: EDITOR_TAB_OPTIONS;
}>(ANALYTICS_ACTIONS.SYNC_DURATION);
